angular.module('impactx.company').controller('CompanyControlSettingCtrl', [
    '$scope',
    'TranslationService',
    CompanyControlSettingCtrl]);

function CompanyControlSettingCtrl($scope, TranslationService) {
    var ctrl = this;
    $scope.search = {value: ""};
    $scope.searchLabel = TranslationService.get('search');

    this.indexOfControl = function(array, control) {
        for(var i = 0; i < array.length; i++) {
            if(array[i].id == control.id) {
                return i;
            }
        }
        return -1;
    };

    this.setReadOnlyControlDataToScope = function(scopeObject) {
        var merged = angular.merge([], scopeObject.readOnlyRelation.assigned, scopeObject.assignedRelation.assigned);
        for(var j = 0; j < scopeObject.readOnlyRelation.assigned.length; j++) {
            scopeObject.readOnlyRelation.assigned[j].denied = undefined;
        }
        for(var i = 0; i < scopeObject.deniedRelation.assigned.length; i++) {
            var index = ctrl.indexOfControl(merged, scopeObject.deniedRelation.assigned[i]);
            if(index >= 0) {
                merged.splice(index, 1);
            }
            var indexReadOnly = ctrl.indexOfControl(scopeObject.readOnlyRelation.assigned, scopeObject.deniedRelation.assigned[i]);
            if (indexReadOnly >= 0)
            {
                scopeObject.readOnlyRelation.assigned[indexReadOnly].denied = true;
            }
        }
    };

    this.filterReadOnly = function()
    {
        if ($scope.search.value != undefined && $scope.search.value.length>0)
        {
            var r =  new RegExp($scope.search.value.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
            $scope.filteredReadOnly = $scope.controlSetting.readOnlyRelation.assigned.filter(function(el)
            {
                return r.test(el.value);
            });
        }
        else
        {
            $scope.filteredReadOnly = $scope.controlSetting.readOnlyRelation.assigned;
        }
    };
    $scope.filteredReadOnly = $scope.controlSetting.readOnlyRelation.assigned;

    this.setReadOnlyControlDataToScope($scope.controlSetting);
}